import { serializeHTML } from 'components/Editor';
import { isUploaded } from 'components/MediaInput';
import { CommentForm, UPLOAD_MEDIA_FIELD } from 'model';
import { Props } from './types';

export const handleFormSubmitted = ({
  contentType,
  onCreateComment: createComment,
  id,
  objectId,
}: {
  contentType: Props['contentType'];
  onCreateComment: Props['onCreateComment'];
  id: Props['id'];
  objectId: Props['objectId'];
}) => ({ comment, [UPLOAD_MEDIA_FIELD]: media }: CommentForm) => {
  const [image] = media.filter(isUploaded);

  createComment({
    contentType,
    objectId,
    comment: serializeHTML(comment),
    image: image?.file,
    parent: id,
  });
};
